export const PhaseItemStatus = {
  finished: 'finished',
  inProgress: 'inProgress',
  notStarted: 'notStarted',
}
